import {Box, createStyles} from '@mantine/core';
import React from 'react';

import {TagSchema} from 'constants/RegistryConstants';
import QueryingTagSchemaSelector from 'schemas/shared/TagSchemaSelector';

// The schema selector's trigger button sizes to its label, which leaves it narrow for short schema
// names. Stretch it to fill the editor row (the selector exposes no width prop of its own).
const useStyles = createStyles({
  fullWidth: {
    width: '100%',
    '& .selectDropdown-button': {
      width: '100%',
    },
  },
});

interface SchemaEditorProps {
  value: string | null;
  onChange: (schemaId: string | null) => void;
  required: boolean;
  disabled?: boolean;
}

export default function SchemaEditor({value, onChange, required, disabled}: SchemaEditorProps): JSX.Element {
  const {classes} = useStyles();
  return (
    <Box className={classes.fullWidth}>
      <QueryingTagSchemaSelector
        // Empty string is unset per the config contract; the selector expects a real id or null.
        selectedTagSchemaId={value || null}
        allowNone={!required}
        isDisabled={Boolean(disabled)}
        onChange={(schema: TagSchema | null) => {
          onChange(schema?.id ?? null);
        }}
        dataTestAttrs={{component: 'SchemaEditor', element: 'selectDropdown'}}
      />
    </Box>
  );
}
